/**
 * StringUtil
 */

class StringUtil {

  static escape( str ) {
    return str
      .replace( /<script>/g, `&lt;script&gt;` )
      .replace( /<\/script>/g, `&lt;/script&gt;` )
      .replace( /<body>/g, `&lt;body&gt;` )
      .replace( /<\/body>/g, `&lt;/body&gt;` );
  }

  static escapeTag( str ) {
    return str.replace( /</g, `&lt;` ).replace( />/g, `&gt;` );
  }

  static decode( str ) {
    return str.replace( /&lt;/g, `<` ).replace( /&gt;/g, `>` );
  }

  static decodeQuot( str ) {
    return str.replace( /&quot;/g, `"` );
  }

  static decodeAll( str ) {
    str = StringUtil.decode( str );
    return StringUtil.decodeQuot( str );
  }

  static fillZero( number ) {
    if ( number < 10 ) {
      return `0${ number }`;
    }
    return number;
  }

  static replaceBr( str ) {
    const regex = /<br\s*[\/]?>/gi;
    return str.replace( regex, `\n` );
  }

  static setWrapLink( url, text ) {
    return `<a href="${ url }">${ text }</a>`;
  }

  static setWrapImage( src ) {
    return `<img src="${ src }" alt="">`;
  }

  static setDefaultByEmptyString( data ) {
    return data || '';
  }

  static replaceTag( reg, content ) {
    const exec = reg.exec( content );
    let c = ``;
    let rep = ``;

    if ( exec && exec.length ) {
      c = exec[ 0 ];
      rep = StringUtil.decodeAll( c );
      return content.replace( c, rep );
    }

    return content;
  }

  static replaceImage( content ) {
    const reg = /(&lt;img src=.+[plaync\.co|ncsoft\.cor].+&gt;+)/;
    return StringUtil.replaceTag( reg, content );
  }

  static replaceEmoticon( content ) {
    const reg = /(&lt;img src=.+[plaync\.co|ncsoft\.cor].+\/resource\/emoticon\/.+&gt;+)/;
    return StringUtil.replaceTag( reg, content );
  }
}

export default StringUtil;
